import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReasonResolve } from './drop-headend-form/reason-resolve.service';
import { DropHeadendComponent } from './drop-headend.component';
import { AuthGuard } from '../../../../core/auth/auth.guard';
import { HeadendIdGuard } from '../shared/headend-id-guard.service';
import { HeadendSummaryResolve } from '../shared/headend-summary-resolve.service';
import { HeadendSummaryClearGuard } from '../shared/headend-summary-clear.guard';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: 'signals/drop',
				component: DropHeadendComponent,
				canActivate: [AuthGuard, HeadendIdGuard],
				canDeactivate: [HeadendSummaryClearGuard],
				resolve: {
					reasons: ReasonResolve,
					headendSummary: HeadendSummaryResolve
				}
			}
		])
	],
	exports: [
		RouterModule
	],
	providers: [
		ReasonResolve,
		HeadendSummaryResolve,
		HeadendIdGuard,
		HeadendSummaryClearGuard
	]
})

export class DropHeadendRoutingModule {
}